<template>
  <b-card-actions title="Tiêu chí" class="m-50" action-collapse>
    <b-card-text>
      <b-row>
        <b-col md="6">
          <b-form-group label="Họ và Tên" label-for="hoVaTen">
            <b-form-input
              id="hoVaTen"
              v-model="formfilters.hoVaTen"
              trim
              placeholder="Họ và Tên"
            />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="CMND/CCCD" label-for="soCmnd">
            <b-form-input
              id="soCmnd"
              v-model="formfilters.soCmnd"
              trim
              placeholder="CMND/CCCD"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Đơn vị">
            <treeselect
              v-on:select="formatDonVis"
              :options="donVis"
              value-format="object"
              v-model="value"
              :searchable="true"
              :show-count="true"
              :default-expand-level="1"
              :normalizer="normalizer"
              placeholder="Chọn đơn vị"
              @input="onChangeDonVi"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Phòng ban" label-for="phongBan">
            <v-select
              placeholder=""
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="formfilters.phongBan"
              :options="listPhongBan"
              :reduce="(val) => val"
              label="name"
              :clearable="true"
              :disabled="isLoaded"
              input-id="phongBan"
            >
            </v-select>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Chức vụ" label-for="chucVu">
            <v-select
              placeholder=""
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="formfilters.chucVu"
              :options="DT_DM_CHUCVU"
              :reduce="(val) => val"
              label="name"
              :clearable="true"
              :disabled="isLoaded"
              input-id="chucVu"
            >
              <template #option="{ name }">
                <span>
                  {{ name }}
                </span>
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card-text>
    <b-card-text>
      <b-collapse id="collapse-1" class="mt-0">
        <b-row>
          <b-col md="4">
            <b-form-group label="Ngạch chức danh" label-for="ngach">
              <v-select
                placeholder=""
                v-model="formfilters.ngach"
                label="name"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="DM_NGACHCHUCDANH"
                :clearable="true"
                :disabled="isLoaded"
                :reduce="(val) => val"
                input-id="ngach"
              >
                <template slot="selected-option" slot-scope="option">
                  <div class="flex">
                    <div class="">
                      <span>{{ option.code }}-{{ option.name }}</span>
                    </div>
                  </div>
                </template>
                <template slot="option" slot-scope="option">
                  <!-- <span class="fa" :class="option.icon"></span> -->
                  {{ option.code }}-{{ option.name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Bậc lương" label-for="bac">
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.bac"
                :options="DM_BACLUONG"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="bac"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Loại biên chế(đối tượng)" label-for="bienChe">
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.bienChe"
                :options="DM_LOAIHOSO"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="bienChe"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Dân tộc" label-for="danToc">
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.danToc"
                :options="DM_DANTOC"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="danToc"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Giới tính" label-for="gioiTinh">
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.gioiTinh"
                :options="DM_GIOITINH"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="gioiTinh"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group label="Tôn giáo" label-for="tonGiao">
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.tonGiao"
                :options="DM_TONGIAO"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="tonGiao"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group
              label="Trình độ giáo dục phổ thông"
              label-for="trinhDoVanHoa"
            >
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.trinhDoVanHoa"
                :options="DM_GIAODUCPHOTHONG"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="trinhDoVanHoa"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Trình độ tiếng anh" label-for="tiengAnh">
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.tiengAnh"
                :options="DM_TRINHDONGOAINGU"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="tiengAnh"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Trình độ tin học" label-for="tinHoc">
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.tinHoc"
                :options="DM_TRINHDOTINHOC"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="tinHoc"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select></b-form-group
            >
          </b-col>

          <b-col md="4">
            <b-form-group label="Trình độ đào tạo" label-for="trinhDoDaoTao">
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.trinhDoDaoTao"
                :options="DM_TRINHDODAOTAO"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="trinhDoDaoTao"
              >
              </v-select>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Lý luận chính trị" label-for="lyLuanChinhTri">
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.lyLuanChinhTri"
                :options="DM_TRINHDOLLCT"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="lyLuanChinhTri"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Quản lý nhà nước" label-for="quanLyNhaNuoc">
              <v-select
                placeholder=""
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.quanLyNhaNuoc"
                :options="DM_TRINHDOQLNN"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="quanLyNhaNuoc"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col>

          <!-- <b-col md="12">
            <b-form-group label="Tiêu chí khác" label-for="otherFilter">
              <v-select
                placeholder=""
                multiple
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                v-model="formfilters.other"
                :options="otherDataFilter"
                :reduce="(val) => val"
                label="name"
                :clearable="true"
                :disabled="isLoaded"
                input-id="otherFilter"
              >
                <template #option="{ name }">
                  <span>
                    {{ name }}
                  </span>
                </template>
              </v-select>
            </b-form-group>
          </b-col> -->
        </b-row>
      </b-collapse>
    </b-card-text>
    <b-card-text class="d-flex justify-content-center">
      <feather-icon
        v-if="isShow"
        @click="showSearch"
        class="text-center"
        icon="ChevronsDownIcon"
        v-b-toggle.collapse-1
        size="18"
      />
      <feather-icon
        v-else
        @click="showSearch"
        class="text-center"
        icon="ChevronsUpIcon"
        v-b-toggle.collapse-1
        size="18"
      />
    </b-card-text>
    <b-card-text class="d-flex justify-content-end">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1 tex"
        :block="$store.getters['app/currentBreakPoint'] === 'xs'"
        :disabled="isLoaded"
        @click="onSearch"
      >
        Tra cứu
      </b-button>
    </b-card-text>
  </b-card-actions>
</template>

<script>
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";
import {
  BCollapse,
  VBToggle,
  BButton,
  BCardText,
  BRow,
  BCol,
  BCard,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Ripple from "vue-ripple-directive";
import { ref } from "@vue/composition-api";
import useSetup from "../useSetup";
import { PhongBanGetList } from "@/services/api/DefaultTemplate/PhongBanService";

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCardActions,
    BCardText,
    vSelect,
    BCollapse,
    BCard,
    Treeselect,
    BFormGroup,
    BFormInput,
  },
  directives: {
    "b-toggle": VBToggle,
    Ripple,
  },
  created() {
    this.fnGetTrinhDoDaoTao();
    this.fnGetGioiTinh();
    this.fnGetDanToc();
    this.fnGetTonGiao();
    this.fnGetTinhTrangHonNhan();
    this.fnGetNgachChucDanh();
    this.fnGetChucVu();
    this.fnGetGiaoDucPhoThong();
    this.fnGetTrinhDoLyLuanChinhTri();
    this.fnGetTrinhDoQuanLyNhaNuoc();
    this.fnGetTrinhDoNgoaiNgu();
    this.fnGetTrinhDoTinHoc();
    this.fnGetNgoaiNgu();
    this.fnGetLoaiHoSo();
    this.fnGetTrangThaiHoSo();
    this.fnGetBacLuong();
  },
  methods: {
    fnGetBacLuong() {
      this.$store.dispatch("common/fetchBacLuong").then((response) => {
        this.DM_BACLUONG = response;
        // console.log("DM_GIOITINH", this.DM_GIOITINH);
      });
    },
    fnGetGioiTinh() {
      this.$store.dispatch("common/fetchGioiTinh").then((response) => {
        this.DM_GIOITINH = response;
        // console.log("DM_GIOITINH", this.DM_GIOITINH);
      });
    },
    fnGetDanToc() {
      this.$store.dispatch("common/fetchDanToc").then((response) => {
        this.DM_DANTOC = response;
      });
    },
    fnGetTonGiao() {
      this.$store.dispatch("common/fetchTonGiao").then((response) => {
        this.DM_TONGIAO = response;
      });
    },
    fnGetTinhTrangHonNhan() {
      this.$store.dispatch("common/fetchTinhTrangHonNhan").then((response) => {
        this.DM_TINHTRANGHONNHAN = response;
      });
    },
    fnGetNgachChucDanh() {
      this.$store.dispatch("common/fetchNgachChucDanh").then((response) => {
        this.DM_NGACHCHUCDANH = response;
      });
    },
    fnGetChucVu() {
      this.$store.dispatch("common/fetchChucVu").then((response) => {
        this.DT_DM_CHUCVU = response;
      });
    },
    fnGetGiaoDucPhoThong() {
      this.$store.dispatch("common/fetchGiaoDucPhoThong").then((response) => {
        this.DM_GIAODUCPHOTHONG = response;
      });
    },
    fnGetTrinhDoDaoTao() {
      this.$store.dispatch("common/fetchTrinhDoDaoTao").then((response) => {
        this.DM_TRINHDODAOTAO = response;
      });
    },
    fnGetTrinhDoLyLuanChinhTri() {
      this.$store
        .dispatch("common/fetchTrinhDoLyLuanChinhTri")
        .then((response) => {
          this.DM_TRINHDOLLCT = response;
        });
    },
    fnGetTrinhDoQuanLyNhaNuoc() {
      this.$store
        .dispatch("common/fetchTrinhDoQuanLyNhaNuoc")
        .then((response) => {
          this.DM_TRINHDOQLNN = response;
        });
    },
    fnGetTrinhDoNgoaiNgu() {
      this.$store.dispatch("common/fetchTrinhDoNgoaiNgu").then((response) => {
        this.DM_TRINHDONGOAINGU = response;
      });
    },
    fnGetTrinhDoTinHoc() {
      this.$store.dispatch("common/fetchTrinhDoTinHoc").then((response) => {
        this.DM_TRINHDOTINHOC = response;
      });
    },
    fnGetNgoaiNgu() {
      this.$store.dispatch("common/fetchNgoaiNgu").then((response) => {
        this.DM_NGOAINGU = response;
      });
    },
    fnGetTrangThaiHoSo() {
      this.$store.dispatch("common/fetchTrangThaiHoSo").then((response) => {
        this.DM_TRANGTHAIHOSO = response;
      });
    },
    fnGetLoaiHoSo() {
      this.$store.dispatch("common/fetchLoaiHoSo").then((response) => {
        this.DM_LOAIHOSO = response;
      });
    },

    formatDonVis(node, instanceId) {
      // this.formfilters.donVi = {
      //   id: node.id,
      //   ten: node.label,
      //   maCoQuan: node.maCoQuan,
      // };
    },
    normalizer(node) {
      // console.log(node);

      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
    onSearch() {
      if (this.value) {
        this.formfilters.donVi = {
          id: this.value.id,
          ten: this.value.label,
          maCoQuan: this.value.maCoQuan,
        };
      } else {
        this.formfilters.donVi = null;
      }

      this.$emit("fetch-data", this.formfilters);
    },
    showSearch() {
      this.isShow = !this.isShow;
    },
    onChangeDonVi(val) {
      if (val && val.id) {
        PhongBanGetList(val.id).then((res) => {
          // console.log(res);
          this.listPhongBan = res.data;
        });
      } else {
        this.listPhongBan = [];
      }
    },
  },
  data() {
    return {
      value: null,
      listPhongBan: [],
      isShow: true,
      formfilters: {},
      DM_BACLUONG: [],
      DM_GIOITINH: [],
      DM_DANTOC: [],
      DM_TONGIAO: [],
      DM_TINHTRANGHONNHAN: [],
      DM_NGACHCHUCDANH: [],
      DT_DM_CHUCVU: [],
      DM_GIAODUCPHOTHONG: [],
      DM_TRINHDODAOTAO: [],
      DM_TRINHDOLLCT: [],
      DM_TRINHDOQLNN: [],
      DM_TRINHDONGOAINGU: [],
      DM_TRINHDOTINHOC: [],
      DM_NGOAINGU: [],
      DM_TRANGTHAIHOSO: [],
      DM_LOAIHOSO: [],
    };
  },
  props: {
    isLoaded: {
      type: Boolean,
      required: true,
    },
    donVis: {
      type: Array,
      // required: true,
    },
  },
  setup(props, { emit }) {
    const dataFilters = ref({});

    const phongBans = ref([]);

    const otherDataFilter = ref([]);

    return {
      dataFilters,
      // formfilters,
      otherDataFilter,

      // onChangeDonVi,
      phongBans,

      // fetchDanhMucData,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
